export default __webpack_public_path__ + "static/media/service-04.dea9e26c.svg";